export const CHUNK_RELOAD_SESSION_KEY = 'candle-chunk-reload';

function isChunkLoadError(error: unknown): boolean {
  const message =
    error instanceof Error
      ? error.message
      : typeof error === 'string'
        ? error
        : '';

  return (
    message.includes('Failed to fetch dynamically imported module') ||
    message.includes('Importing a module script failed') ||
    message.includes('error loading dynamically imported module') ||
    message.includes('Loading chunk') ||
    message.includes('Loading CSS chunk')
  );
}

/**
 * Retry once after a full reload when a lazy route chunk is missing (stale tab
 * after deploy). Prevents endless Suspense spinners and raw router crashes.
 */
export async function lazyImportWithRetry<T>(loader: () => Promise<T>): Promise<T> {
  try {
    const module = await loader();
    sessionStorage.removeItem(CHUNK_RELOAD_SESSION_KEY);
    return module;
  } catch (error) {
    if (!isChunkLoadError(error)) {
      throw error;
    }

    const alreadyReloaded = sessionStorage.getItem(CHUNK_RELOAD_SESSION_KEY) === '1';
    if (!alreadyReloaded) {
      sessionStorage.setItem(CHUNK_RELOAD_SESSION_KEY, '1');
      window.location.reload();
      return new Promise<T>(() => {});
    }

    sessionStorage.removeItem(CHUNK_RELOAD_SESSION_KEY);
    throw error;
  }
}
